<template>
    <FullContainer>
        <slot></slot>
        <slot name="table"></slot>
    </FullContainer>
</template>

<script setup>
</script>

<style lang="scss">
@use "./index.scss";
</style>
